export const initialState = {
    user: null
} 

export const actionTypes = {
    SET_USER: "SET_USER",
}

// takes in state and the change we're trying to make
const reducer = (state, action) => {


    switch(action.type) {
        case actionTypes.SET_USER: 
        return {
            ...state,
            user: action.user
    }

        default: 
            return state
}
}

export default reducer 